import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./procedureSelection-modal.page.html",
  styleUrls: ["./procedureSelection-modal.page.scss"],
})
export class ProcedureSelectionModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  procedureSelectionList: any;
  procedureSelectionSelectedList: any;
  loadingDone: boolean = false;
  searchText: string = "";

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global
  ) {}

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;

    this.GetProcedureSelectionList();
  }

  async onProcedureSelectionSelect(event: any, procedureSelection: any) {
    await this.modalCtrl.dismiss(procedureSelection);
  }

  GetProcedureSelectionList() {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("UserToken", this.globals.XRSUser.UserToken);
    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("Vendor_GUID", this.Vendor_GUID);
    formData.append("search", this.searchText);
    formData.append("filter", "AllProcedureSelection");
    formData.append("sort", "Created");
    formData.append("take", "" + 20);
    formData.append("skip", "" + 0);
    formData.append("callingFilter", "" + this.callingFilter);
    formData.append("User_GUID", "" + this.User_GUID);
    formData.append("referancePage", "Scope of Work");

    this.appservice.GetProcedureList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;
        this.procedureSelectionList = JSON.parse(res.toString());
      } catch (e) {}
    });

    return subject.asObservable();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.procedureSelectionSelectedList);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.procedureSelectionSelectedList);
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
